/**
 * Cart 도메인 쿼리 키 팩토리
 */

export const cartKeys = {
  all: ["carts"] as const,
  list: () => ["carts", "list"] as const,
  count: () => ["carts", "count"] as const,
  brandInfo: (brandIds: number[]) => ["carts", "brand-info", brandIds] as const,
};
